import { useState } from 'react';
import { Button, Snackbar, Alert, Box } from '@mui/material';
import { linkedinLogin } from '../services/authService';
import linkedinIcon from '../assets/logos/icons-linkedin-48.svg';

export default function LinkedInLoginButton() {
  const [error, setError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const showError = (message) => {
    setError(message);
    setOpenSnackbar(true);
  };

  const handleLinkedInLogin = async () => {
    setLoading(true);
    try {
      const response = await linkedinLogin();
      if (response.authUrl) {
        // Redirect to LinkedIn OAuth
        window.location.href = response.authUrl;
      } else {
        showError('Failed to initiate LinkedIn authentication');
      }
    } catch (error) {
      console.error('LinkedIn login error:', error);
      showError('LinkedIn authentication failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
      <Button
        variant="outlined"
        onClick={handleLinkedInLogin}
        disabled={loading}
        fullWidth
        sx={{
            borderRadius: 2,
            fontSize: '0.75rem',
            color: '#18181b',
            borderColor: "#1ce484", 
            boxShadow: '0 4px 24px 0 rgba(56, 65, 74, 0.07)',
            '&:hover': {
              background: '#f1f5f9',
              borderColor: '#3b82f6',
            },
        }}
        startIcon={
          <img
            src={linkedinIcon}
            alt="LinkedIn"
            style={{ width: 25, height: 25 }}
          />
        }
      >
       <Box sx={{ display: { xs: 'none', md: 'block' }, pt:0, pb:0 }}>
            {loading ? 'Connecting...' : 'Sign In with LinkedIn'}
          </Box>
          <Box sx={{ display: { xs: 'block', md: 'none' }, pt:0, pb:0 }}>
            {loading ? 'Connecting...' : 'LinkedIn'}
          </Box>
      </Button>
      </Box>

      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
} 